/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/passiveAlertView.html';

import appCustomConfig from '../config';

import {faTimes} from '@fortawesome/pro-solid-svg-icons';
const icons = Base.initializeIcons({
	faTimes,
});

export default class PassiveAlertView extends Base {
	/** @method */
	constructor(opts = {}) {
		opts.events = {
			'click [data-nx-control="close"]': 'dismiss',
			'hover .hit': 'onHover',
			'mouseout .hit': 'onMouseOut',
			...opts.events,
		};
		opts.icons = {...icons, ...opts.icons};
		opts.id = opts.id || 'passive-alert';
		opts.template = opts.template || Template;

		super(opts);

		this.timer = null;
	}

	/** @override */
	bindModelEvents() {
		super.bindModelEvents();

		return this.listenTo(this.model, 'change', this.render);
	}

	/** @override */
	postRender() {
		super.postRender();

		this.timer && clearTimeout(this.timer);

		$('body').scrollTop(0);
		this.timer = setTimeout(this.dismiss, appCustomConfig.PASSIVE_ALERT_DELAY);
	}

	/**
	 * @method
	 * @param {event} e `click` event
	 */
	dismiss(e) {
		$('body').removeClass('passive-alert');
	}

	/**
	 * @method
	 * @param {event} e `hover` event
	 */
	onHover(e) {
		this.timer && clearTimeout(this.timer);
	}

	/**
	 * @method
	 * @param {event} e `mouse` event
	 */
	onMouseOut(e) {
		if (e.clientY > 50) {
			// not close button
			this.dismiss();
		}
	}

	/** @type {string} */
	static get __name__() {
		return 'PassiveAlertView';
	}
}
